import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.PageContent', {
    auditReportPreviewTitle: 'Audit report for "{requestDisplayName}"',
    changeSearchButtonText: 'Change search settings',
    changeSearchButtonTitle: 'Change search settings',
    companyAllEmptyTitle: 'There are no requests that you have submitted in this Organisation',
    companyMyOpenEmptyTitle: 'There are no open requests that you have submitted in this Organisation',
    defaultEmptyTitle: 'There are no requests',
    myDecisionRequiredEmptyText: 'Ask your colleagues if they have something in the pipeline',
    myDecisionRequiredEmptyTitle: "There's nothing to approve",
    myReviewRequiredEmptyTitle: "There's nothing to review",
    myDraftEmptyTitle: 'There are no Drafts. Create new request',
    myOpenEmptyTitle: 'There are no open requests that you have submitted',
    newRequestButtonText: 'Create new request',
    newRequestButtonTitle: 'New request button',
    newSearchButtonTitle: 'Search',
    onStatusEmptyTitle: 'There are no {templateName} {filterName}',
    requestVersionTitle: 'Version #{version}, {date}',
    searchNotFoundText: 'No requests were found',
    searchingNowText: 'Please wait, search is in progress...',
    setupNewWorkflowButtonText: 'Setup a new workflow',
    templateRequestEmptyTitle: 'There are no {filterName} {templateName}',
    successRecognitionText: 'Document capture has been completed. Refresh the page to see the results.',
    errorRecognitionText: 'ApprovalMax Capture has failed to recognize your file',
    errorRecognitionButtonText: 'Let`s try again',
    ocrDocumentIsEmptyText: 'No data has been extracted from {fileName}. Please upload another file.',
    ocrDocumentIsEmptyButtonText: 'Let`s try again',
    requests: 'Requests',
});
